<template>
    <my-dialog ref="editForm" title="采购入库单详情" dialogType="form" :visible.sync="showDialog" :close-on-click-modal="false"
        @close="closeDialog" width="80%">
        <div class="main_bg">
            <div class="item_info border_Warningcolor">
                <el-descriptions class="margin-top" title="基本信息" :column="3" border>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-mobile-phone"></i>
                            入库单号
                        </template>
                        {{ this.editForm.inputStoreNo }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            入库人
                        </template>
                        {{ this.editForm.inputUserName }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            入库时间
                        </template>
                        {{ this.editForm.inputDate }}
                    </el-descriptions-item>
                    <el-descriptions-item span="3">
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            备注
                        </template>
                        {{ this.editForm.remark }}
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <div class="item_info border_Green">
                <div class="item_title">
                    <div class="title">商品信息</div>
                </div>
                <div class="tableData">
                    <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading" border>
                        <el-table-column v-if="isShowMoney" slot="price" label="单价" width="100" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.price }}
                            </template>
                        </el-table-column>
                        <el-table-column v-if="isShowMoney" slot="money" label="金额" width="100" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.money }}
                            </template>
                        </el-table-column>
                    </STable>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeDialog">关闭</el-button>
            <el-button
                v-if="btnPermission.audit && (this.editForm.inputUserKeyId === '' || this.editForm.inputUserName === null)"
                size="small" type="primary" class="el-icon-audit" @click="auditInputStore()">审核</el-button>
        </div>
    </my-dialog>
</template>
<script>
import { GetInputStoreDeatail, AuditInputStore } from "@/api/receiptApi.js";
export default {
    props: [],
    data() {
        return {
            showDialog: false,
            editForm: {
                keyId: "",
                inputStoreNo: "",
                inputUserName: "",
                inputDate: "",
                remark: "",
            },
            goodsInfoData: [],
            loading: false, // 显示加载
            listData: [],
            columnsData: [], //显示列
            listColumns: [
                {
                    prop: "rowNumber",
                    label: "序号",
                    align: "center",
                    fixed: "left",
                    width: "80",
                    isKeep: true,
                    type: "index",
                },
                {
                    prop: "supplyName",
                    label: "供应商",
                    align: "center",
                    wdth: "60",
                },
                {
                    prop: "goodsInfo.type",
                    label: "商品品牌",
                    align: "center",
                    isKeep: true,
                    wdth: "100",
                },
                {
                    prop: "goodsInfo.name",
                    label: "商品名称",
                    align: "center",
                    minWidth: "220",
                },
                {
                    prop: "goodsInfo.qiuJing",
                    label: "球镜",
                    wdth: "60",
                    align: "center",
                },
                {
                    prop: "goodsInfo.zhuJing",
                    label: "柱镜",
                    align: "center",
                    wdth: "60",
                },
                {
                    slot: "price",
                    label: "单价",
                    align: "center",
                    wdth: "60",
                },
                {
                    prop: "quantity",
                    label: "数量",
                    align: "center",
                    wdth: "60",
                },
                {
                    slot: "money",
                    label: "金额",
                    align: "center",
                    wdth: "60",
                }
            ],
            isShowMoney: false,
            // 按钮权限
            btnPermission: {
                audit: false,
            },
        };
    },
    computed: {},
    watch: {},
    components: {},
    created() {
        // 按钮权限
        this.getBtnPermission();
    },
    methods: {
        // 显示
        showDetailDialog(keyId) {
            this.editForm.keyId = keyId;
            this.showDialog = true;
            // 初始列
            this.getCheckBox(this.listColumns.map((item) => item.label));
            this.getListData();
            let userdata = JSON.parse(localStorage.getItem("userdata"));
            if (userdata.roleInfo.keyId == "2f91e757a9c4444dbe13146a363a717c") {
                this.isShowMoney = true;
            } else {
                this.isShowMoney = false;
            }
        },
        // 获取筛选框
        getCheckBox(val) {
            let arr = this.listColumns.filter((v) => !val.includes(v.label));
            this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
        },
        // 获取入库单详情
        getListData() {
            this.loading = true;
            const params = {
                keyId: this.editForm.keyId,
            };
            GetInputStoreDeatail(params)
                .then((res) => {
                    if (res.code == 1) {
                        this.editForm.inputStoreNo = res.data.inputStoreNo;
                        this.editForm.remark = res.data.remark;
                        this.editForm.inputUserName = res.data.inputUserName;
                        this.editForm.inputDate = res.data.inputDate;
                        this.goodsInfoData = res.data.dtls;

                        this.loading = false;
                        this.listData = res.data.dtls;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("生成失败，请稍后再试！");
                });
        },
        // 关闭
        closeDialog() {
            this.$data.editForm = this.$options.data.call(this).editForm;
            this.loading = false;
            this.showDialog = false;
        },
        //判断为空则用 -- 替代
        transformEmpty(obj) {
            if (obj == "" || obj == null || obj == undefined) {
                obj = "--";
            }
            return obj;
        },
        // 审核
        auditInputStore() {
            this.$confirm("确定要审核入库单【" + this.editForm.inputStoreNo + "】吗?", "信息", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                let parmter = {
                    keyIds: [this.editForm.keyId],
                };
                AuditInputStore(parmter)
                    .then((res) => {
                        if (res.code === 1) {
                            this.$message({
                                type: "success",
                                message: "已成功审核入库单【" + row.inputStoreNo + "】!",
                            });
                            this.showDialog = false;
                            this.$parent.getListData();
                        } else {
                            this.$message({
                                type: "info",
                                message: res.msg,
                            });
                        }
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$message.error("审核失败，请稍后再试！");
                    });
            });
        },
        // 按钮权限
        getBtnPermission() {
            this.btnPermission.audit = this.$checkBtnPermission('/inputStore/index', 'audit');
        },
    },
};
</script>
<style scoped lang="scss">
.main_bg {
    padding: 10px;
    margin-top: -15px;
}

.item_info {
    border-left: 5px solid #55aaff;
    padding: 5px 10px;
    border-radius: 5px;
    margin-bottom: 15px;
    border-bottom: 2px solid #e9e7e7;
}

.border_Warningcolor {
    border-left: 5px solid #ff9900;
}

.border_Green {
    border-left: 5px solid #00cc66;
}

.item_title {
    display: flex;
    width: 100%;
    font-weight: 700;
    font-size: 1rem;
    margin-bottom: 10px;
    justify-content: space-between;

    .title {
        display: inline-block;
        unicode-bidi: isolate;
    }

    .goodsInfoData {
        font-size: 18px;
        font-weight: 900;
        font-family: "楷体";
    }
}
</style>